import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ZorroTableComponent } from "../../../../components/common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../../../components/common/loading/loading.component";
import { ConfigService } from "../../../../core/services/config/config.service";
import { RestTcoService } from "../../../../core/services/rest-tco.service";
import { TcoProjectService } from "../../../../core/services/tco-project/tco-project.service";
import { UtilitiesService } from "../../../../core/services/utilities.service";
import { segmentationThresholdColumns } from "../../../../core/table-templates/segmentation-threshold-table";

/**
 * Component for handling and displaying segmentation threshold data.
 */
@Component({
  selector: "app-segmentation-threshold",
  standalone: true,
  imports: [CommonModule, LoadingComponent, ZorroTableComponent],
  templateUrl: "./segmentation-threshold.component.html",
  styleUrl: "./segmentation-threshold.component.scss",
})
export class SegmentationThresholdComponent implements OnInit {
  records: any = {
    columns: segmentationThresholdColumns,
  };
  isLoading = false;
  extractedRealm: string | null;
  selectedFile: any;
  isProcessing:boolean = false;
  isDisabled = true;
  selectedRows:any =[];
  options :any = {isSelectAll:true};
  @Output() moveToPreviousTabEvent = new EventEmitter<string>();
  /**
   * Emits an event to move to the next tab.
   * @type {EventEmitter<void>}
   */
  @Output() moveToNextTabEvent = new EventEmitter<void>();

  /**
   * Creates an instance of PreProcessingComponent.
   * @param data The data passed from a parent component or service, injected via "STEP_DATA".
   */
  constructor(
    private restTcoService: RestTcoService,
    private configService: ConfigService,
    private utilityService: UtilitiesService,
    private tcoProjectService: TcoProjectService
  ) {
    this.extractedRealm = this.configService.getConfig("isDomainResolver")
      ? this.utilityService?.extractRealmFromUrl()
      : sessionStorage.getItem("selectedRealm");

    this.tcoProjectService.getSelectedFile().subscribe((file) => {
      this.selectedFile = file;
    });
  }

  /**
   * Lifecycle hook that is called when the component is initialized.
   * It triggers the loading of records.
   */
  ngOnInit() {
    this.loadRecords();
    if (this.selectedRows?.length === 0) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  /**
   * Loads the segmentation threshold records.
   * Sets the loading flag to true during the process and false when done.
   * After loading, populates the `records` object with sample data.
   */
  loadRecords() {
    this.isLoading = true;
    this.restTcoService.getAllModels().subscribe(
      (item) => {
        this.records["rows"] = item;
        this.isLoading = false;
      },
      (error) => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  segmentationProcess() {
    this.isProcessing = true;
    console.log("Segmantation", this.selectedRows);

    const requestBody = {
      // quality_threshold: this.records?.rows,
      quality_threshold: this.selectedRows,
      tenantId: this.extractedRealm,
    };
    this.restTcoService.prosessFileStep3(requestBody).subscribe(
      (item) => {
        this.isProcessing = false;
        console.log(item);
        this.isLoading = false;
        if (item?.message === "SUCCESS") {
          const requestData = {
            tenantId: this.extractedRealm,
          };
          this.restTcoService.executepython(requestData).subscribe(
            (res) => {
              this.isProcessing = false;
              const stepDescription = this.records?.rows?.find(
                (item: any) => item.featureName === "Step Description"
              );
              const expectedResults = this.records?.rows?.find(
                (item: any) => item?.featureName === "Expected Results"
              );
              const now = new Date();
              const data = {
                name: `model_${now.toISOString().split("T")[0]}_${now
                  .toTimeString()
                  .split(" ")[0]
                  .replace(/:/g, "-")}`,
                author: "",
                publishDateTime: this.formatToLocalTime(
                  new Date().toISOString()
                ),
                trainedDateTime: this.formatToLocalTime(
                  new Date().toISOString()
                ),
                source: this.selectedFile?.size ? this.selectedFile.size.toString() : "0",
                totalTestCasesClusterCount: res.TotalTestCasesClusterCount,
                totalTestCasesCount: res.TotalTestCasesCount,
                topicLevelClusterClusterCount:
                  res.TopicLevelClusterClusterCount,
                topicLevelClusterCount: res.TopicLevelClusterCount,
                uniqueTestCasesClusterCount: res.UniqueTestcasesClusterCount,
                uniqueTestCasesCount: res.UniqueTestcasesCount,
                duplicateTestcaseClusterCount:
                  res.DuplicateTestcaseClusterCount,
                duplicateTestcaseCount: res.DuplicateTestcaseCount,
                mergeableTestCasesClusterCount:
                  res.MergeableTestCasesClusterCount,
                mergeableTestCasesCount: res.MergeableTestCasesCount,
                stepDescriptionDuplicateLB: stepDescription.duplicateData1,
                stepDescriptionDuplicateUB: stepDescription.duplicateData2,
                stepDescriptionMergeableLB: stepDescription.mergeableData1,
                stepDescriptionMergeableUB: stepDescription.mergeableData2,
                expectedResultsDuplicateLB: expectedResults.duplicateData1,
                expectedResultsDuplicateUB: expectedResults.duplicateData2,
                expectedResultsMergeableLB: expectedResults.mergeableData1,
                expectedResultsMergeableUB: expectedResults.mergeableData2,
              };

              this.restTcoService.savemodel(data).subscribe(
                (item) => {
                  this.isProcessing = false;
                  this.isLoading = false;
                  console.log("Modal Save", item);
                  this.moveToNextTabEvent.emit();
                },
                (error) => {
                  this.isProcessing = false;
                  this.isLoading = false;
                }
              );
            },
            (error) => {
              this.isProcessing = false;
              this.isLoading = false;
            }
          );
        } else {
          this.isProcessing = false;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isProcessing = false;
        this.isLoading = false;
      }
    );
  }

  formatToLocalTime = (dateTimeString: any) => {
    const dateTime = new Date(dateTimeString);
    return dateTime.toLocaleString();
  };

  handleRowSelection(event: any) {
    this.selectedRows = event.data.filter((item: any) => item.select === true);

    if (this.selectedRows?.length === 0) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }
  goBack() {
    this.moveToPreviousTabEvent.emit("Metadata Catalogue");
  }
}
